/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import { ErrorText } from "../common/errorText"
import { FieldName } from "../common/text"
import { IDateFieldProperties } from "./generic/form/DatePickerField"
import SeasonDatePicker from "./SeasonDatePicker"
import { differenceInCalendarDays, addDays, isBefore } from "date-fns"
import { formatDate } from "./Utils"

interface Props extends IDateFieldProperties {
  turnaroundDays: number
  startDate: string
  hasSelectedStartDate: boolean
  dateHasError?: boolean
}

const SeasonDepartureDatePicker: React.FunctionComponent<Props> = ({
  turnaroundDays,
  startDate,
  onChange,
  placement,
  hasChanges,
  readonly,
  dateHasError,
  dateHasErrText,
  hasSelectedStartDate
}) => {
  const [maxDate, setMaxDate] = useState<Date>(null)
  const [departureDate, setDepartureDate] = useState<string>(
    turnaroundDays !== null && startDate
      ? formatDate(addDays(new Date(startDate), turnaroundDays))
      : null
  )

  useEffect(() => {
    let updTurnaroundDays = undefined

    if (!departureDate && startDate) {
      updTurnaroundDays = 0
      setDepartureDate(startDate)
    }

    if (startDate && departureDate) {
      if (isBefore(new Date(departureDate), new Date(startDate))) {
        updTurnaroundDays = 0
        setDepartureDate(startDate)
      } else {
        updTurnaroundDays = differenceInCalendarDays(
          new Date(departureDate),
          new Date(startDate)
        )
      }
    }

    if (!startDate) {
      updTurnaroundDays = null
    }

    if (turnaroundDays !== undefined) {
      onChange(FieldName.turnaroundDays, updTurnaroundDays)
    }
    setMaxDate(startDate ? addDays(new Date(startDate), 99) : null)
  }, [hasSelectedStartDate])

  const handleDateChange = (name: string, val: string) => {
    let _val = null
    if (startDate && val) {
      const fromDate = new Date(startDate)
      const toDate = new Date(val)
      _val = differenceInCalendarDays(toDate, fromDate)
    }

    const error = name === "turnaroundDays" && val === null

    setDepartureDate(val)
    onChange(name, _val, error)
  }

  return (
    <SeasonDatePicker
      name={FieldName.turnaroundDays}
      //   isAddPage={isAdd}
      //  touched={true}
      required
      validationError={ErrorText.noDate}
      value={departureDate}
      isEmpty={departureDate === null || dateHasError}
      hasError={dateHasError}
      onChange={handleDateChange}
      readonly={readonly}
      placement={placement}
      max={maxDate}
      hasChanges={hasChanges}
      min={startDate ? new Date(startDate) : null}
      dateHasErrText={dateHasErrText}
    />
  )
}

export default SeasonDepartureDatePicker

